export { default } from './RecordSync';
